import { BlogSection } from '@/types/blog';

export const meinungsfreiheitSection: BlogSection = {
  id: 'meinungsfreiheit',
  title: 'Was Meinungsfreiheit wirklich braucht',
  content: `
    <p>
      Meinungsfreiheit ist kein Freifahrtschein, sondern ein Versprechen, das nur wirkt, wenn Menschen fähig sind, mit Meinungen umzugehen. Das bedeutet, Widersprüche auszuhalten, Kritik anzunehmen und Verantwortung für die eigenen Worte zu übernehmen. Diese Fähigkeit wächst nicht durch Gesetze, sondern durch Beziehungskultur und Vorbilder.
    </p>
  `
};
